import { AccessRule, AccessRuleOwner, User } from '@prisma/client';

import { Role } from '@app/domain-interfaces';
import { Auth } from '@app/web-components';

interface IAccessRuleWithOwners extends AccessRule {
  owners: (AccessRuleOwner & { user: User })[];
}

export const useCanEditAccessRule = () => {
  const { user } = Auth.useUserAuth();

  const canEditAccessRule = (record?: IAccessRuleWithOwners) =>
    user?.roles[Role.SYSTEM_ADMIN] ||
    (user?.roles[Role.RULE_ADMIN] && record?.owners.some((x) => x.user.id === user?.id));

  return { user, canEditAccessRule };
};
